import { DEFAULT_AMANDA_AGENT_CONFIG } from "./amanda-agent-config";
const DEFAULT_REDIRECT_DELAY_MS = 5000;
export default {
    amandaAgentConfig: JSON.stringify(DEFAULT_AMANDA_AGENT_CONFIG),
    qualifiedRedirectDelayMs: DEFAULT_REDIRECT_DELAY_MS,
    unqualifiedRedirectDelayMs: DEFAULT_REDIRECT_DELAY_MS,
    agentChatStepTextLabels: {
        eyebrow: "Hi <monday-lead-var first_name there />, we've got your details!",
        title: "Let's connect you with the right person",
        stepYourInfoLabel: "Your info",
        stepTellUsMoreLabel: "Tell us more",
        stepMeetWithUsLabel: "Connect",
        firstMessage: "Hi {{first_name}}, I'm Amanda 👋<br>" + "Here to get you to the right person.<br>" + "Can you tell me a bit about your team's needs for {{main_product}}?"
    },
    meetWithUsStepTextLabels: {
        title: "Let's find a time to meet",
        stepFormLabel: "Form",
        stepTellUsMoreLabel: "Tell us more",
        stepMeetWithUsLabel: "Book a time"
    },
    thankYouStepTextLabels: {
        eyebrow: "Hi <monday-lead-var first_name there />, we've got your details!",
        title: "Let's connect you with the right person",
        stepYourInfoLabel: "Your info",
        stepTellUsMoreLabel: "Tell us more",
        stepDoneLabel: "Done",
        thankYouBadgeImage: {
            src: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/NaamaGros/Group_2.png",
            alt: "Done"
        },
        thankYouTitle: "Thanks for submitting your request!",
        thankYouSubtitle: "Our sales team will be in touch by email or phone call to discuss next steps.",
        helpCenterPrefix: "You can check out our",
        helpCenterLinkText: "Help Center",
        helpCenterLinkUrl: "https://support.monday.com",
        helpCenterSuffix: "for additional resources.",
        recordingDisclaimer: "Please be aware that by default our calls are recorded for note taking and to improve our services. If you'd rather the call not be recorded, just let our experts know."
    }
};
